import { useNavigate, useLocation } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Sparkles } from 'lucide-react'

const toolLabels: Record<string, string> = {
  'caption-writer': 'Caption Writer',
  'content-ideas': 'Content Ideas',
  'best-time': 'Best Time to Post',
  'schedule-post': 'Schedule Post',
}

const ComingSoonPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const slug = location.pathname.split('/').pop() ?? ''
  const label = toolLabels[slug] ?? 'This Feature'

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <Sparkles className="h-10 w-10 text-[#4d7c0f] mb-4" />
      <h1 className="text-2xl font-bold text-foreground mb-2">{label}</h1>
      <p className="text-gray-600 mb-6">This feature is coming soon.</p>
      <Button
        onClick={() => navigate('/')}
        className="bg-[#C0FD72] text-black hover:bg-[#d2ff9c] font-semibold"
      >
        Back to Dashboard
      </Button>
    </div>
  )
}

export default ComingSoonPage
